import _defineProperty from "@babel/runtime/helpers/defineProperty";
import FormHelperText from "@material-ui/core/FormHelperText";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
export class ErrorHandlingFormHelperText extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "render", () => {
      const {
        muiFormControl
      } = this.context;
      const {
        id,
        helperText,
        errorMessage,
        className
      } = this.props;
      let {
        error,
        disabled
      } = this.props;
      if (muiFormControl) {
        if (muiFormControl.error !== undefined) {
          error = muiFormControl.error;
        }
        if (muiFormControl.disabled !== undefined) {
          disabled = muiFormControl.disabled;
        }
      }
      return helperText || error && errorMessage ? /*#__PURE__*/React.createElement(FormHelperText, {
        id: `${id}-helper-text`,
        error: error,
        disabled: disabled,
        className: classNames("prmbl-errorHandlingFormHelperText", className)
      }, error ? errorMessage : helperText) : "";
    });
  }
}
_defineProperty(ErrorHandlingFormHelperText, "propTypes", {
  /**
   * Classes to apply to the root
   */
  className: PropTypes.string,
  /**
   * If `true` the label, input, and helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true` the label will be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * The contents of the helper text when `error` is true
   */
  errorMessage: PropTypes.node,
  /**
   * The contents of the helper text when `error` is false
   */
  helperText: PropTypes.node,
  /**
   * The html id
   */
  id: PropTypes.string
});
_defineProperty(ErrorHandlingFormHelperText, "contextTypes", {
  muiFormControl: PropTypes.object
});
export default ErrorHandlingFormHelperText;